<template>
  <v-app>
      <MainPage></MainPage>
  </v-app>
</template>

<script>
import MainPage from './components/MainPage.vue'

export default {
  name: 'app',
  components: {
    MainPage
  }
}
</script>

<style>
#app {
  background-color: rgb(158, 158, 158);
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>

